import React from 'react';
import { bool, func, object, number } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isRecurringGig, isTriplePackage } from '../../../../reducers/packages';
import { PACKAGES_TABLE } from '../../../../utils/pageSections';
import { shouldShowSelectPackage } from '../../../../utils/shouldShowSelectPackage';
import CheckoutPlans from './CheckoutPlans';
import CompareBtn from './CompareBtn';
import CtaBtn from './CtaBtn';

import './style.scss';

const TabFooter = ({
    showCompareAnchor = true,
    currentPrice,
    isRecurringGig
}, { general, currencyConverter, scrollToSection }) => {
    const showSelectPackage = shouldShowSelectPackage(general);
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);

    if (!showSelectPackage && !showCompareAnchor && !isRecurringGig) {
        return null;
    }

    const wrapperClass = classNames(
        'tab-footer',
        { 'recurring-gig': isRecurringGig }
    );

    const onComparePackagesClick = () => scrollToSection({ sectionKey: PACKAGES_TABLE });

    return (
        <footer className={wrapperClass}>
            {isRecurringGig && <CheckoutPlans/>}
            {showSelectPackage && <CtaBtn price={formattedPrice}/>}
            {showCompareAnchor && <CompareBtn onComparePackagesClick={onComparePackagesClick}/>}
        </footer>
    );
};

TabFooter.propTypes = {
    showCompareAnchor: bool,
    currentPrice: number
};

TabFooter.contextTypes = {
    general: object,
    currencyConverter: object,
    scrollToSection: func
};

const mapStateToProps = ({ packages }) => ({
    isRecurringGig: isRecurringGig(packages),
    showCompareAnchor: isTriplePackage(packages)
});

export { TabFooter };
export default connect(mapStateToProps)(TabFooter);
